import { Component, ViewChild, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { Events, AlertController, ToastController } from 'ionic-angular';

import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { PublicShareServiceProvider } from '../../providers/public-share-service/public-share-service';
import { HomePage } from '../../pages/home/home';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { SharePage } from '../../pages/share/share';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
@Component({
  selector: 'public-share',
  templateUrl: 'public-share.html'
})
export class PublicShareComponent {

  @ViewChild('loadHomePage', { read: ViewContainerRef, static: false }) loadHomePage: ViewContainerRef;

  componentRef: any;
  SharedInfo: any = {};
  sharedData: any = {};
  currentScreenProps: any
  showComponentholder: any = false;
  components: any;
  ShareID: any;
  Email_ID: any = '';
  broadcastSubs: any;
  constructor(public communicationServ: CommunicationServiceProvider, private componentFactoryResolver: ComponentFactoryResolver, public toastMessage: ToastController, public alertController: AlertController, public publicShareService: PublicShareServiceProvider, public events: Events, public configApiService: ConfigApiServiceProvider, public driveService: DriveServiceProvider, public configService: ConfigureServiceProvider, public storeWrap: StoreWrapProvider, public EncrDecrService: EncrDecrServiceProvider) {
  }

  ngOnInit() {
    let urlParams = '';
    if (window.location.search.split('&').length > 1) {
      for (var i = 0; i < window.location.search.split('&').length; i++) {
        if (window.location.search.split('&')[i].split('=')[0] == 'ShareID') {
          urlParams = window.location.search.split('&')[i].split('=')[1];
          break;
        }
      }
    } else {
      urlParams = window.location.search.split('=')[1];
    }

    urlParams = urlParams.replace(/%22/g, '"');
    urlParams = 'ShareID=' + this.EncrDecrService.decrypt('DRIVESYNC123##', urlParams);


    for (var j = 0; j < urlParams.split('&').length; j++) {
      if (urlParams.split('&')[j].split("=")[0] == "ShareID") {
        this.ShareID = urlParams.split('&')[j].split("=")[1]
      } else if (urlParams.split('&')[j].split("=")[0] == "studio") {
        this.configService.setStudio(urlParams.split('&')[j].split("=")[1]);
      } else if (urlParams.split('&')[j].split("=")[0] == "userid") {
        this.configService.setLoginUserID(urlParams.split('&')[j].split("=")[1]);
      }
    }

    /* * * * * * * * *
    * Get app components from component holder service
    * * * * * * * * */
    this.components = this.publicShareService.getComponents();
    this.driveService.componentList = this.components;
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "defaultProps") {
          if (data.event === 'pullAppComponents') {
            let flag = data['status'];
            if (flag) {
              this.driveService.broadcastInfo({ src: 'comp-main', event: 'getAppComponents', status: true, components: this.components });
            }
          }
        }
      })
  }

  ngAfterViewInit() {
    this.getConfigurationData();
  }

  /********
   * Call SHare Data through share id
   * ******* */
  getConfigurationData() {
    let shareData = Object.assign({}, this.configApiService.driveApi.pullLinkShareUser, { "ShareID": this.ShareID, 'userid': this.configService.getLoginUserID() });
    this.configApiService.pullRequest(shareData, responseData => {
      if (responseData.length != 0) {
        let currentAppDetails = {}
        let LoginUserDetails = {}
        currentAppDetails = JSON.parse(responseData[0]["SharedInfo"]).pullFolderTemplate.currentAppDetails
        LoginUserDetails = JSON.parse(responseData[0]["SharedInfo"]).pullFolderTemplate.LoginUserDetails
        if (currentAppDetails != undefined) {
          this.configApiService.currentDriveApp = currentAppDetails;
        }
        if (LoginUserDetails != undefined) {
          this.driveService.LoginUserDetails = LoginUserDetails;
        }
        this.driveService.setShareUserData(responseData[0]);
        this.pullShareData(responseData);
      }
    })
  }


  pullShareData(responseData) {
    if (responseData.length > 0) {
      this.configApiService.currentDriveApp.app_code = eval("(" + responseData[0]["SharedInfo"] + ")").pullFolderTemplate['app_code'];
      this.configApiService.currentDriveApp['StudioAppCode'] = eval("(" + responseData[0]["SharedInfo"] + ")").pullFolderTemplate['client'];
      /************
       * Drive Configuration Api request Call
       * *********** */
      this.loaddriveConfigurationData(responseData);
    }
  }

  /**********
   * LOAD SYSTEM API DATA
   * ********* */
  loaddriveConfigurationData(responseData) {
    this.configApiService.pullApiData(data => {
      this.SharedInfo = Object.assign({}, responseData[0], eval("(" + responseData[0]["SharedInfo"] + ")"));
      this.sharedData = { 'sharedInfo': this.SharedInfo, 'ShareType': this.SharedInfo.ShareType, 'ReceiverEmail': responseData[0].ReceiverEmail };
      this.SharedInfo['sharedFolder']['IsReadOnlyShare'] = this.SharedInfo['AccessType'] == 'Editable' ? 'NO' : 'YES';
      if (this.SharedInfo['mailSendType'] != undefined && this.SharedInfo['mailSendType'] == 'Group') {
        this.driveService.objCurrentFolder = this.driveService.objCurrentParentFolder = this.driveService.assignFolderStructure('publicShare', this.SharedInfo['sharedFolder'].template, this.SharedInfo['sharedFolder']);
        this.driveService.getTemplates((templateData) => {
          this.loadSharedFolder();
        });
      } else {
        if (this.sharedData.ShareType != "Folder") {
          if (!this.SharedInfo['sharedFolder'].name) {
            this.driveService.objCurrentFolder = this.driveService.objCurrentParentFolder = this.driveService.assignFolderStructure('publicShare', this.SharedInfo['sharedFolder'].template, this.SharedInfo['sharedFolder']);
            this.SharedInfo['sharedFolder'] = this.driveService.objCurrentFolder;
          } else {
            var shareFolderName = eval("(" + responseData[0]["SharedInfo"] + ")").sharedFolder.name;
            this.driveService.objCurrentFolder = this.driveService.objCurrentParentFolder = this.driveService.assignFolderStructure(shareFolderName, this.SharedInfo['sharedFolder'].template, this.SharedInfo['sharedFolder']);
            this.SharedInfo['sharedFolder'] = this.driveService.objCurrentFolder;
          }
        } else {
          this.driveService.objCurrentFolder = this.SharedInfo['sharedFolder'];
        }
        if (this.SharedInfo['accessType'] == 'private') {
          this.showComponentholder = false;
          this.loadComponent();
        } else {
          this.storeWrap.pullData(0, null, this.driveService.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeTemplate, (templateData) => {
            if (this.sharedData.ShareType == "Folder") {
              this.driveService.objCurrentParentFolder = this.driveService.objCurrentFolder;
              this.loadSharedFolder();
            } else {

              this.loadTemplateProperty(templateData);

            }
          });
        }
      }
    });
  }

  loadSharedFolder() {
    this.driveService.loader.dismiss();
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(SharePage);
    this.componentRef = this.loadHomePage.createComponent(componentFactory);
    this.componentRef.instance.sharedData = this.sharedData;
  }

  /**************
   * Template Property
   * **** *********/
  loadTemplateProperty(templateData) {
    this.driveService.loader.dismiss();
    let arrTemplateProps = [];
    if (this.SharedInfo['sharedFolder']["template"].length > 1) { // changing the validation to 1 from >1
      for (let idx = 0; idx < this.SharedInfo['sharedFolder']["template"].length; idx++) {
        if (this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][idx].id]) {
          arrTemplateProps.push(this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][idx].id]);
        } else {
          let _template = Object.assign({}, this.configApiService.driveApi.pullFolderTemplate.params, this.SharedInfo.pullFolderTemplate, { "ScreenName": this.SharedInfo.sharedFolder.template[idx].id });
          /*********
           *pull specific template detail
           * ********** */
          this.configApiService.pullRequest(_template, (temp) => {

            this.storeWrap.storeTemplates[eval('(' + temp[0].PluginData + ')')['id']] = eval('(' + temp[0].PluginData + ')');
            arrTemplateProps.push(this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][idx]['id']]);
          });
        }
      }

    } else {
      if (!this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][0]['id']]) {
        let _template = Object.assign({}, this.configApiService.driveApi.pullFolderTemplate.params, this.SharedInfo.pullFolderTemplate, { "ScreenName": this.SharedInfo.sharedFolder.template[0].id });
        this.configApiService.pullRequest(_template, (temp) => {

          this.storeWrap.storeTemplates[eval('(' + temp[0].PluginData + ')')['id']] = eval('(' + temp[0].PluginData + ')');
          if (this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][0]['id']]['componentName'] == 'FormGridComponent') {
            this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][0]['id']]['componentName'] = "FORM";
          }
          arrTemplateProps.push(this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][0]['id']]);
        })
      } else {
        if (this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][0]['id']]['componentName'] == 'FormGridComponent') {
          this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][0]['id']]['componentName'] = "FORM";
        }
        arrTemplateProps.push(this.storeWrap.storeTemplates[this.SharedInfo['sharedFolder']["template"][0]['id']]);
      }
    }
    this.currentScreenProps = arrTemplateProps[0];
    this.showComponentholder = true;
    setTimeout(() => {
      this.driveService.broadcastInfo({ src: 'compLoad', event: 'triggerComponentLoad', status: 'editdata', item: arrTemplateProps, param: this.sharedData.sharedInfo.rowData[0], isShare: true });
    }, 500);
  }

  loadComponent() {
    this.driveService.loader.dismiss();
    // this.loadHomePage.clear();      
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(HomePage);
    this.componentRef = this.loadHomePage.createComponent(componentFactory);
    this.componentRef.instance.sharedData = this.sharedData;
    this.componentRef.instance.sharePageActive = true;
    // this.driveService.objCurrentFolder = this.SharedInfo['sharedFolder'];
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/components/public-share/public-share.ts